import { addCollection } from '@iconify/react';
import { getIcons } from '@iconify/utils';
import { icons as fluentData } from '@iconify-json/fluent';
import { icons as tablerData } from '@iconify-json/tabler';

const FLUENT_METRIC_CARD_ICONS = [
  'hat-graduation-20-regular',
  'person-money-20-regular',
  'book-contacts-28-regular',
  'document-one-page-add-24-regular',
  'document-table-arrow-right-24-regular',
  'clipboard-text-edit-32-regular',
  'wallet-credit-card-32-regular',
  'line-horizontal-5-error-20-regular',
  'chat-20-regular',
] as const;

const TABLER_METRIC_CARD_ICONS = ['cash-move-back'] as const;

let registered = false;

export const registerMetricCardOfflineIcons = (): void => {
  if (registered || typeof window === 'undefined') {
    return;
  }

  const fluentIcons = getIcons(fluentData, [...FLUENT_METRIC_CARD_ICONS], true);

  if (fluentIcons) {
    addCollection(fluentIcons);
  }

  const tablerIcons = getIcons(tablerData, [...TABLER_METRIC_CARD_ICONS], true);

  if (tablerIcons) {
    addCollection(tablerIcons);
  }

  registered = true;
};
